export default __webpack_public_path__ + "static/media/kurir.b68aa847.png";